import React from "react";
import usePageMeta from "../usePageMeta";

function PrivacyPolicy() {
  usePageMeta(
    "Privacy Policy – Hisaab Tools",
    "Privacy policy for Hisaab Tools: what data is and isn't collected, cookies, and Google AdSense advertising."
  );

  return (
    <main className="page">
      <div className="calc-card fade-in">
        <h1>Privacy Policy</h1>
        <div className="seo-content seo-content-plain">
          <p>
            <em>Last updated: July 15, 2026</em>
          </p>

          <h2>Your calculations stay on your device</h2>
          <p>
            All calculators on this site run entirely in your web browser. The
            numbers and dates you enter are never transmitted to our servers,
            logged, or stored. Closing the page discards everything you typed.
          </p>

          <h2>Information we collect</h2>
          <p>
            We do not require accounts and do not collect names, email
            addresses, or other personal information. Like most websites, our
            hosting provider may keep standard technical logs (such as IP
            address, browser type, and pages visited) for security and
            performance purposes.
          </p>

          <h2>Advertising and cookies</h2>
          <p>
            This site is supported by advertising served by Google AdSense.
            Google, as a third-party vendor, uses cookies to serve ads based
            on your prior visits to this and other websites. Google's use of
            advertising cookies enables it and its partners to serve ads to
            you based on your visits to this site and/or other sites on the
            Internet.
          </p>
          <p>
            You may opt out of personalized advertising by visiting{" "}
            <a
              href="https://www.google.com/settings/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Ads Settings
            </a>
            . You can also opt out of some third-party vendors' use of cookies
            for personalized advertising at{" "}
            <a
              href="https://www.aboutads.info"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.aboutads.info
            </a>
            .
          </p>

          <h2>Third-party links</h2>
          <p>
            Pages on this site may link to external websites. We are not
            responsible for the content or privacy practices of those sites
            and encourage you to review their privacy policies.
          </p>

          <h2>Children's privacy</h2>
          <p>
            This site is a general-audience website and does not knowingly
            collect personal information from children under 13.
          </p>

          <h2>Changes to this policy</h2>
          <p>
            We may update this policy from time to time. Any changes will be
            posted on this page with an updated revision date.
          </p>
        </div>
      </div>
    </main>
  );
}

export default PrivacyPolicy;
